import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { userSignal } from "../../../signal/userSignal";
import { DEV_SERVER } from "../../../constants/urls";
import axios from "axios";
import { useQuery } from "react-query";
import { allUsersSignal } from "../../../signal/allUsersSignal";
import { toast } from "react-toastify";
import { Accordion, Badge, Card, Col, Image, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { dealerSignal } from "../../../signal/dealerSignal";
import Avatar from "react-avatar";
import { organisationSignal } from "../../../signal/organisationSignal";
import DataTable from "react-data-table-component";
import * as moment from "moment";
import avatar1 from "../../../assets/images/avatars/01.png"
import AddEditOrder from "./AddEditOrder";
import Select from "react-select";


export default function OrderList() {
    let today = Date.now();
    // get date start Time of 7 days ago in milliseconds
    let sevenDaysAgo = new Date(today - 7 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [orders, setOrders] = useState([]);
    const [ordersToDisplay, setOrdersToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(sevenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [dealerId, setDealerId] = useState(searchParams.get("dealerId") ? searchParams.get("dealerId") : "");
    const [userId, setUserId] = useState(searchParams.get("userId") ? searchParams.get("userId") : "");
    const [minAmount, setMinAmount] = useState(searchParams.get("minAmount") ? parseFloat(searchParams.get("minAmount")) : 0);
    const [maxAmount, setMaxAmount] = useState(searchParams.get("maxAmount") ? parseFloat(searchParams.get("maxAmount")) : 0);
    const [stageFilter, setStageFilter] = useState(searchParams.get("stageFilter") ? searchParams.get("stageFilter") : "");
    const [search, setSearch] = useState("");
    const [showAddOrderModal, setShowAddOrderModal] = useState(false);

    const navigate = useNavigate();

    const refetchOrders = () => {
        getOrders.refetch({ cancelRefetch: true });
    }

    const handleDisplayFields = () => {
        setOrdersToDisplay(orders.filter((item) => {

            if (stageFilter && stageFilter !== "") {
                if (item.currentOrderStage !== stageFilter) return false;
            }
            
            if (minAmount && item.totalAmount < minAmount) return false;
            if (maxAmount && item.totalAmount > maxAmount) return false;
            if (search === "") return true;
            if (moment(item?.createdAt).format("DD/MM/YY").toLowerCase().includes(search.toLowerCase())) return true;
            if (allUsersSignal?.value[item.userId] && allUsersSignal?.value[item.userId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (dealerSignal?.value[item.dealerId] && dealerSignal?.value[item.dealerId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.currentOrderStage.toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.subTotal).toFixed(2).toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.totalAmount).toFixed(2).toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.totalItems.toString().toLowerCase().includes(search.toLowerCase())) return true;
            if (parseFloat(item?.userCommissionInPercentage).toFixed(2).toString().toLowerCase().includes(search.toLowerCase())) return true;
            return false;
        }))
    }

    const getOrders = useQuery("orders", async () => {
        let resp = await axios.get(`${DEV_SERVER}/order/v2?startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 59)}&dealerId=${dealerId}&userId=${userId}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },

        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                let stateName = window.localStorage.getItem("state");
                let temp = data.data
                if (stateName) {
                    temp = temp.filter((item) => {
                        return allUsersSignal.value[item.userId]?.state === stateName
                    })
                }

                setOrders(temp);

            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    useEffect(() => {
        handleDisplayFields();
    }, [search, orders])

    useEffect(() => {

        refetchOrders();
    }, [])

    const handleFilters = async () => {

        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate: toDate, minAmount: minAmount, maxAmount: maxAmount, stageFilter: stageFilter, dealerId: dealerId, userId: userId });
        setSearchParams(tempSearchParam);

        await refetchOrders();
        handleDisplayFields();
    }

    const columns = [
        {
            name: "Date",
            center: true,
            selector: "createdAt",
            cell: (row) => `${moment(row?.createdAt).format("DD/MM/YY")}`,
            sortable: true,
        },
        {
            name: "Dealer",
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/orders/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            {(dealerSignal.value && dealerSignal.value[row?.dealerId]?.visitingCard?.length && dealerSignal.value[row?.dealerId]?.visitingCard?.length!==0) ?
                                <img
                                    style={{ width: "20px", height: "20px" }}
                                    src={(dealerSignal.value && dealerSignal.value[row?.dealerId]?.visitingCard?.length && dealerSignal.value[row?.dealerId]?.visitingCard?.length !==0) ? dealerSignal.value[row?.dealerId]?.visitingCard[0]?.url : ""}
                                    className="rounded-circle avatar-xs"
                                    alt="friend"
                                />

                                : <>
                                    <Avatar name={dealerSignal.value ? dealerSignal.value[row?.dealerId]?.name : ""} size="20" round style={{ borderRadius: "50% !important", width: "20px !important", height: "20px !important", overflow: 'unset' }} />
                                </>}
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {dealerSignal.value ? dealerSignal.value[row?.dealerId]?.name : ""}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{dealerSignal.value ? dealerSignal.value[row?.dealerId]?.name : ""}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        },
        {
            name: "Stage",
            center: true,
            selector: (row) => {
                return <Badge onClick={() => navigate(`/dashboard/orders/${row?.id}`)} bg="none" style={{backgroundColor: organisationSignal?.value?.orderStageColors[row?.currentOrderStage]}} text="white">{row?.currentOrderStage}</Badge>
            }
        },
        {
            name: "Total Amount",
            center: true,
            selector: "totalAmount",
            cell: (row) => row?.totalAmount > 10000 ? `${parseFloat(row?.totalAmount / 1000).toFixed(2)}K Rs` : `${parseFloat(row?.totalAmount).toFixed(2)} Rs`,
            sortable: true,
        },
        {
            name: "Total Items",
            center: true,
            selector: "totalItems",
            sortable: true
        },
        {
            name: "Created By",
            center: true,
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div onClick={() => navigate(`/dashboard/orders/${row?.id}`)} className="d-flex align-items-center" style={{ columnGap: "0.4rem" }}>
                            <img
                                style={{ width: "20px", height: "20px" }}
                                src={(allUsersSignal.value[row?.userId]?.profileURL === "" || allUsersSignal.value[row?.userId]?.profileURL === undefined) ? avatar1 : allUsersSignal.value[row?.userId]?.profileURL}
                                className="rounded-circle avatar-xs"
                                alt="friend"
                            />
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {allUsersSignal.value[row?.userId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            }
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Order List</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", rowGap: "0.7rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" defaultValue={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" defaultValue={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="minAmount">Min Amount</label>
                                                    <input type="number" id="minAmount" className="form-control" names="start" placeholder="Min Amount" value={minAmount} onChange={(e) => {
                                                        setMinAmount(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxAmount">Max Amount</label>
                                                    <input type="number" id="maxAmount" className="form-control" names="start" placeholder="Max Amount" value={maxAmount} onChange={(e) => {
                                                        setMaxAmount(e.target.value)
                                                    }} />
                                                </div>

                                                <div>
                                                    <label htmlFor="maxAmount">Dealer</label>
                                                    <Select
                                                        options={dealerSignal.value && Object.keys(dealerSignal.value).map((key) => {
                                                            return { value: dealerSignal.value[key].id, label: dealerSignal.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if(e && e.value){
                                                                setDealerId(e.value);
                                                            }else {
                                                                setDealerId("");
                                                            }
                                                        }}

                                                        value={(dealerSignal.value && dealerSignal.value[dealerId]) ? { value: dealerSignal.value[dealerId].id, label: dealerSignal.value[dealerId].name } : null}

                                                        isClearable
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="maxAmount">User</label>
                                                    <Select
                                                        options={Object.keys(allUsersSignal?.value).map((key) => {
                                                            return { value: allUsersSignal?.value[key].id, label: allUsersSignal?.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if(e && e.value){
                                                                setUserId(e.value);
                                                            }else {
                                                                setUserId("");
                                                            }
                                                        }}

                                                        value={allUsersSignal?.value[userId] ? { value: allUsersSignal?.value[userId].id, label: allUsersSignal?.value[userId].name } : null}

                                                        isClearable
                                                    />
                                                </div>

                                                <div>
                                                    <label htmlFor="stageFilter">Stage</label>
                                                    <select id="stageFilter" className="form-control vanila-datepicker" names="start" placeholder="Status" value={stageFilter} onChange={(e) => {
                                                        setStageFilter(e.target.value)
                                                    }}>
                                                        <option value="">All</option>
                                                        {organisationSignal.value?.orderStageTypes?.length && organisationSignal.value?.orderStageTypes.map((item) => {
                                                            return <option key={item} value={item}>{item}</option>
                                                        })}
                                                    </select>
                                                </div>

                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(sevenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(today).format("YYYY-MM-DD"));
                                                    setMinAmount(0);
                                                    setMaxAmount(0);
                                                    setStageFilter("");
                                                    setDealerId("");
                                                    setUserId("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(sevenDaysAgo).format("YYYY-MM-DD"), toDate: moment(today).format("YYYY-MM-DD"), minAmount: 0, maxAmount: 0, stageFilter: "", dealerId: "", userId: "", page: 1, perPage: 35 });
                                                    setSearchParams(tempSearchParam);
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="mt-3" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", columnGap: "1rem", marginBottom: "1rem" }}>
                                    <div>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => {
                                            setSearch(e.target.value)
                                        }} />
                                    </div>
                                    <button className="btn btn-primary" onClick={() => {
                                        setShowAddOrderModal(true);
                                    }}>Add Order</button>
                                </div>
                                {(!getOrders.isLoading && !getOrders?.isFetching) && <DataTable
                                    columns={columns}
                                    data={ordersToDisplay}
                                    pagination={true}
                                    onRowClicked={(row) => navigate(`/dashboard/orders/${row?.id}`)}
                                    customStyles={{
                                        rows: {
                                            style: {
                                                cursor: "pointer",
                                                backgroundColor: "unset"
                                            }
                                        }
                                    }}
                                    paginationPerPage={searchParams.get("perPage") ? parseInt(searchParams.get("perPage")) : 35}
                                    paginationRowsPerPageOptions={[10, 15, 20, 25, 30, 35]}
                                    paginationDefaultPage={searchParams.get("page") ? parseInt(searchParams.get("page")) : 1}
                                    onChangeRowsPerPage={(e, page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("perPage", e)
                                        setSearchParams(currentSearchParam)
                                    }}
                                    onChangePage={(page) => {
                                        let currentSearchParam = searchParams
                                        currentSearchParam.set("page", page)
                                        setSearchParams(currentSearchParam)
                                    }}
                                />}
                                {(getOrders.isLoading || getOrders?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                }
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>

            {showAddOrderModal && <AddEditOrder show={showAddOrderModal} close={() => setShowAddOrderModal(false)} refetchOrder={() => refetchOrders()} />} 
        </>
    )
}